export const EVENTS = {
  home: {
    landed: {
      eventName: ' LANDED_ON_HOME',
    },
  },
  contact: {
    landed: {
      eventName: ' LANDED_ON_CONATCT',
    },
  },
  pricing: {
    landed: {
      eventName: ' LANDED_ON_PRICING',
    },
    signUpClicked: {
      eventName: 'FREE_SIGN_UP_CLICKED',
    },
    sliderClicked: {
      eventName: 'SLIDER_CLICKED',
    },
  },
  about: {
    landed: {
      eventName: ' LANDED_ON_ABOUT',
      eventParams: {},
    },
  },
  product: {
    landed: {
      eventName: ' LANDED_ON_PRODUCT',
      eventParams: {},
    },
  },
}
